module.exports = __webpack_public_path__ + "img/componente_11.bf20623c.png";